export default __webpack_public_path__ + "0f2ae1cc622676da076e9fde33087539.png";